import * as yup from 'yup';

import { schema as companyDetailsSchema } from '../../CompanyDetails/CompanyDetailsUK/CompanyDetailsUK.schema';
import { loanDetailsSchemaUK } from '../../LoanFields/loanFields.schema';

export const schema = yup
  .object()
  .shape({
    email: yup
      .string()
      .email('Please use a valid email format')
      .matches(/^[^\s@]+@[^\s@]+\.[^\s@]+$/, {
        message: 'Please use a valid email format',
        excludeEmptyString: true,
      })
      .required('Email address required'),
  })
  .concat(loanDetailsSchemaUK)
  .shape({
    marketingOptIn: yup.boolean().optional(),
  });

export const variantSchema = schema
  .pick(['email', 'marketingOptIn'])
  .concat(companyDetailsSchema);
